import React from 'react';
import { observer } from 'mobx-react';
import { Drawer } from 'antd';

import { useStores } from '@/hooks/use-stores';
import { useDeviceDrawerActions } from '@/hooks/useDeviceDrawerActions';

import MinimizedView from './MinimizedView/MinimizedView';

const MinimizedDrawer = observer(({ mainContainerRef }: { mainContainerRef: React.RefObject<HTMLDivElement> }) => {
  const { mapBuilderStore } = useStores();
  const { closeDeviceDrawer } = useDeviceDrawerActions();

  return (
    <Drawer
      open={mapBuilderStore.isDetailsModalMinimized}
      onClose={closeDeviceDrawer}
      closeIcon={false}
      placement="bottom"
      height="fit-content"
      getContainer={mainContainerRef.current}
      rootClassName="minimized-modal"
      mask={false}
    >
      <MinimizedView />
    </Drawer>
  );
});

export default MinimizedDrawer;
